import { GraphBuilder } from '../graph/builder';
import { ComponentDef } from './types';

export const ppInterleavedComponent: ComponentDef = {
  id: 'pp-interleaved',
  name: 'PP Interleaved',
  description: 'Interleave pipeline stages across microbatches to improve bubble-time utilization.',
  category: 'parallelism',
  params: [
    { name: 'd_model', label: 'Model dimension', type: 'number', default: 512, min: 64, max: 4096, step: 64 },
    { name: 'pp_size', label: 'Pipeline stages', type: 'number', default: 4, min: 2, max: 16, step: 1 },
    { name: 'microbatches', label: 'Microbatches', type: 'number', default: 4, min: 1, max: 32, step: 1 }
  ],
  buildGraph: (params) => {
    const d_model = Number(params.d_model);
    const pp_size = Number(params.pp_size);
    const microbatches = Number(params.microbatches);

    const g = new GraphBuilder();
    g.input('x', [d_model]);

    let current = 'x';
    for (let i = 0; i < pp_size; i++) {
      const linearId = `stage_${i}`;
      const p2pId = `p2p_${i}`;
      g.linear(linearId, current, [d_model, d_model]);
      g.scale('schedule', linearId, `${microbatches} microbatches`);
      g.p2p(p2pId, 'schedule', [d_model]);
      current = p2pId;
    }
    g.output('out', current);
    return g.build();
  }
};
